import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/shared/services/globals';
import { Alert } from '../../../models/alert.model';
import { SieniService } from 'src/app/shared/services/sieni.service';
import { PdaService } from 'src/app/shared/services/pda.service';
import { LoadingService } from 'src/app/shared/components/loading/loading.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-modal-action',
  templateUrl: './modal-action.component.html',
  styleUrls: ['./modal-action.component.scss'],
})
export class ModalActionComponent implements OnInit {
  @Input() title: any;
  @Input() from: string;
  @Input() members: any;
  @Input() causesDef: any;
  @Input() checkedMembers: any;
  @Input() disabled: boolean = false;
  loading: boolean = false;
  content: string;
  datosFormulario: FormGroup;
  users: any = [];
  causas: any = [];
  dropdownList = [];
  selectedItems = [];
  selectedCausas = [];
  dropdownSettings = {};
  membersForm: FormGroup;
  causasForm: FormGroup;
  members_input: any = [];
  causas_input: any = [];
  placeholder: string;
  @Output() public emitActionPlanData = new EventEmitter();

  @Output() clickClose = new EventEmitter();
  @Output() clickDismiss = new EventEmitter();
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private modalService: NgbModal,
    private globals: GlobalsService,
    private _sieni_service: SieniService,
    private _pda: PdaService,
    private _loading: LoadingService
  ) {}

  ngOnInit(): void {
    this.translate.currentLang == 'es'
      ? (this.placeholder = 'Seleccionar')
      : 'Select';
    // this.dropdownSettings = {
    //   singleSelection: false,
    //   idField: 'id',
    //   textField: 'name',
    //   selectAllText:
    //     this.translate.currentLang == 'es' ? 'Seleccionar todo' : 'Select All',
    //   unSelectAllText:
    //     this.translate.currentLang == 'es'
    //       ? 'Deseleccionar todo'
    //       : 'Un Select All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true,
    //   noDataAvailablePlaceholderText:
    //     this.translate.currentLang == 'es'
    //       ? 'Datos no disponibles'
    //       : 'No data available',
    //   searchPlaceholderText:
    //     this.translate.currentLang == 'es' ? 'Buscar' : 'Search',
    //   maxHeight: 50,
    // };
    this.membersForm = this.fb.group({
      members: [{ value: '', disabled: this.disabled }, Validators.required],
    });
    this.causasForm = this.fb.group({
      causas: [{ value: '', disabled: this.disabled }, Validators.required],
    });
    if (this.checkedMembers.length) {
      if (this.from == 'responsable') {
        // this.selectedItems = this.checkedMembers;
        this.members.forEach((element, index, array) => {
          element.checked = false;
          this.checkedMembers.forEach((element2, index2, array2) => {
            if (element.id === element2.id) {
              element.checked = true;
            }
          });
        });
      } else if (this.from == 'corresponsable') {
        this.members.forEach((element, index, array) => {
          element.checked = false;
          this.checkedMembers.forEach((element2, index2, array2) => {
            if (element2.select) {
              if (element.id === element2.id) {
                element.checked = true;
              }
            }
          });
        });
        this.checkedMembers.forEach((element) => {
          if (!element.select) {
            this.members_input.push({ name: element.name });
          }
        });
      } else if (this.from == 'causas') {
        // console.log("CAUSAS MODAL",this.checkedMembers,this.causesDef);
        
        this.checkedMembers.forEach((element) => {
          if (element.select) {
            this.causesDef.forEach(element2 => {
              if(element.id==element2.id){
                element2.checked = true;
              }
            });
          } else {
            this.causas_input.push({ name: element.name, id: element.id });
          }
        });
      }
    } else {
      this.members.forEach((element) => {
        element.checked = false;
      });
      this.causesDef.forEach(element => {
        element.checked = false;
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.causesDef.forEach(element => {
      element.checked = false;
    });
  }
  btnClose() {
    this.add_member();
    let data;
    this.selectedItems = this.members.filter((x) => x.checked);
    if (this.from == 'responsable' || this.from == 'corresponsable') {
      data = this.members_input.concat(this.selectedItems);
    } else {
      this.causesDef.map((x)=>x.name= x.titulo)
      this.causas = this.causesDef.filter((x) => x.checked);
      data = this.causas_input.concat(this.causas);
    }

    this.clickClose.emit(data);
    this.activeModal.close();
  }

  btnDismiss() {
    this.clickDismiss.emit('dismiss');
    this.activeModal.dismiss();
  }

  getMembers() {
    setTimeout(() => {
      //<<<---using ()=> syntax
      this.users = this.members;
      this.loading = false;
    }, 1000);
  }
  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  add_member() {
    if (this.membersForm.valid) {
      var index = this.members_input.findIndex(
        (x) => x.name == this.membersForm.get('members').value
      );
      var index2 = this.users.findIndex(
        (x) => x.name == this.membersForm.get('members').value
      );
      // here you can check specific property for an object whether it exist in your array or not

      index === -1 && index2 === -1
        ? this.members_input.push({
            name: this.membersForm.get('members').value,
          })
        : console.log('object already exists');
      this.membersForm.reset();
    }
  }
  delete_member(i) {
    this.members_input.splice(i, 1);
  }
  add_causas() {
    if (this.causasForm.valid) {
      var index = this.causas_input.findIndex(
        (x) => x.name == this.causasForm.get('causas').value
      );
      var index2 = this.causas.findIndex(
        (x) => x.name == this.causasForm.get('causas').value
      );
      // here you can check specific property for an object whether it exist in your array or not

      index === -1 && index2 === -1
        ? this.causas_input.push({
            name: this.causasForm.get('causas').value,
            id: '',
          })
        : console.log('object already exists');
      this.causasForm.reset();
    }
  }
  delete_causas(i) {
    this.causas_input.splice(i, 1);
  }
  ngAfterViewInit(): void {
    this.loading = true;
    this.getMembers();
  }
}
